<script>
import { defineComponent, onMounted, provide, ref } from 'vue'
import { RouterView, useRoute } from 'vue-router'
//controller
import ModalMaster from '../modal/ModalMaster.vue'
//festure
import useModalStore from "../../store/ModalStore";
import useAccountStore from "../../store/AccountStore";
import useLocaleStore from "../../store/LocaleStore";
import useModalSetup from "../../composable/useModalSetup";
import LandingFlow from "../../composable/LandingFlow";
export default defineComponent({
    components: {
        RouterView,
        ModalMaster
    },
    setup() {
        const isInit = ref(false)
        const ModalStore = useModalStore();
        const LocaleStore = useLocaleStore()
        const AccountStore = useAccountStore()
        

        useModalSetup(ModalStore)

        const landingFlow = LandingFlow({
            mainAppName: "topup2c2p"
        },
            AccountStore,
            LocaleStore
        )

        onMounted(() => {
            const route = useRoute()
            landingFlow.events.onReady = async () => {
                isInit.value = true
            }
            landingFlow.init(route.params)
        })
        console.log("landingFlow", landingFlow)
        provide("ModalStore", ModalStore)
        provide("LocaleStore", LocaleStore)
        provide("AccountStore", AccountStore)

        return {
            isInit,
            modalController: ModalStore.methods.getModalController()
        }
    }
})
</script>
<template>
    <div class="font-main">
        <RouterView v-if="isInit"></RouterView>
        <ModalMaster :controller="modalController" ></ModalMaster>
    </div>
</template>
<style lang="scss">
    @import "../../style/main.scss";
    
</style>
